import AuthGuard from './auth-guard'
import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/Home'
import signin from '@/views/user/signin'
import userProfile from "@/views/user/userProfile";
// twilio phonenumbers
import getNewPhoneNumber from "@/views/phoneNumbers/getNewPhoneNumber"
import managePhoneNumbers from "@/views/phoneNumbers/managePhoneNumbers"
import numberPortal from "@/views/phoneNumbers/numberPortal";
import userContactsProfile from "@/views/user/userContactsProfile";
import segments from '@/views/marketing/segments'
import segmentManager from "@/views/marketing/segmentManager";
//commerce
import listings from "@/views/inventories/listings"
import listing from "@/views/inventories/listing"
import item from "@/views/inventories/item";
import addOnItem from "@/views/inventories/addOnItem";
import bookings from "@/views/bookings/bookings"
import booking from '@/views/bookings/booking'
import transactionsList from "@/views/transactions/transactionsList";
import segmentViewer from "@/views/marketing/segmentViewer";
import stripeCheckout from "@/views/transactions/stripeChargeCheckout"
import transactionStatus from "@/views/transactions/transactionStatus";
import quote from "@/views/bookings/quote.vue";
import passwordReset from "@/views/user/passwordReset.vue";
import emailVerified from "@/views/user/emailVerified.vue";
import billingAndUsage from "@/views/billing/billingAndUsage.vue";
import billingStripeChargeCheckout from "@/views/billing/billingStripeChargeCheckout.vue";
import billingTransactionStatus from "@/views/billing/billingTransactionStatus.vue";
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/signin',
      name: 'signin',
      component: signin
    },
    {
      path: '/resetPassword',
      name: 'resertPassword',
      component: passwordReset
    },
    {
      path: '/verifyEmail',
      name: 'emailVerified',
      component: emailVerified
    },
    {
      path: '/billingAndUsage',
      name: 'billingAndUsage',
      component: billingAndUsage,
      beforeEnter: AuthGuard
    },
    {
      path: '/editProfile',
      name: 'userProfile',
      component: userProfile,
      beforeEnter: AuthGuard
    },
    {
      path: '/getNewPhoneNumber',
      name: 'GetNewPhoneNumber',
      component: getNewPhoneNumber,
      beforeEnter: AuthGuard
    },
    {
      path: '/managePhoneNumbers',
      name: 'ManagePhoneNumber',
      component: managePhoneNumbers,
      beforeEnter: AuthGuard
    },
    {
      path: '/numberPortal/:phoneNumber',
      name: 'numberPortal',
      props: true,
      component: numberPortal,
      beforeEnter: AuthGuard
    },
    {
      path: '/numberPortal/:phoneNumber/:contactNumber',
      name: 'userContactProfile',
      props: true,
      component: userContactsProfile,
      beforeEnter: AuthGuard
    },
    {
      path: '/segments/:uid/:phoneNumber',
      name: 'segments',
      props: true,
      component: segments,
      beforeEnter: AuthGuard
    },
    {
      path: '/segments/:uid/:phoneNumber/:segmentId',
      name: 'segment',
      props: true,
      component: segmentManager,
      beforeEnter: AuthGuard
    },
    {
      path: '/segmentViewer',
      name: 'segmentViewer',
      component: segmentViewer,
      beforeEnter: AuthGuard
    },
    {
      path: '/listings',
      name: 'listings',
      component: listings,
      beforeEnter: AuthGuard
    },
    {
      path: '/listing/:id',
      name: 'listing',
      props: true,
      component: listing,
      beforeEnter: AuthGuard
    },
    {
      path: '/listing/:listingId/item/:itemId',
      name: 'inventoryItem',
      props: true,
      component: item,
      beforeEnter: AuthGuard
    },
    {
      path: '/listing/:listingId/addOnitem/:itemId',
      name: 'addOnItem',
      props: true,
      component: addOnItem,
      beforeEnter: AuthGuard
    },
    {
      path: '/booking/:id',
      name: 'Booking',
      props: true,
      component: booking,
      beforeEnter: AuthGuard
    },
    {
      path: '/quote/:quoteId/:activeListingId',
      name: 'Quote',
      props: true,
      component: quote,
      beforeEnter: AuthGuard
    },
    {
      path: '/bookings',
      name: 'bookings',
      component: bookings,
      beforeEnter: AuthGuard
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: transactionsList,
      beforeEnter: AuthGuard
    },
    {
      path: '/stripeCheckout',
      name: 'stripeCheckout',
      component: stripeCheckout,
      beforeEnter: AuthGuard
    },
    {
      path: '/transactionStatus/:transactionId',
      name: 'transactionStatus',
      props: true,
      component: transactionStatus,
      beforeEnter: AuthGuard
    },
    {
      path: '/billingStripeCheckout',
      name: 'billingStripeCheckout',
      component: billingStripeChargeCheckout,
      beforeEnter: AuthGuard
    },
    {
      path: '/billingTransactionStatus/:transactionId',
      name: 'transactionStatus',
      props: true,
      component: billingTransactionStatus,
      beforeEnter: AuthGuard
    },
  ],
  mode: 'history'
})
